/**
 * The key a block is addressed by on a page: calculation requests and
 * results, the block's slot in the calculation store, its `CalculationScope`.
 *
 * A Strapi `id` is unique only within a component type — a Comparison Table
 * and a carousel can both be `3` — so the type is part of the key. Derived,
 * not stored: the same content yields the same key on the server and the
 * client, and in tapes and snapshots.
 */
export const blockKey = (component: {
  __typename?: string;
  id?: string | number | null;
}): string => `${component.__typename}:${component.id}`;
